import React, { useEffect, useState, useRef, Fragment } from "react"
import { Link, useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Select, { components } from 'react-select'
import MaskedInput from 'react-text-mask'
import { toast } from 'react-toastify'
import { Modal } from 'react-bootstrap'
import { SketchPicker } from "@hello-pangea/color-picker";

import Size from './Size'
import Modifiers from './Modifier'
import ReactSelect from 'pages/parts/ReactSelect'

import { GET, POST, PUT, FILE, DELETE, httpOk } from 'helpers/api'
import { findKeyFromArrayByValue, formatDate, formatMoney } from "helpers/helpers"
import { smiles } from "helpers/smiles"
import DeleteModal from "pages/parts/DeleteModal"

function CreateUpdate() {
	const { t } = useTranslation()
	const { posId, id } = useParams()
	const navigate = useNavigate()

	const inputRef = useRef(null);
	const tbodyRef = useRef()
	const scrollRef = useRef()

	const writeOffTypes = [
		{ 'id': 1, 'name': t('ingredients') },
		{ 'id': 2, 'name': t('product') },
	]

	const [data, setData] = useState({
		'name': '',
		'menu_id': '',
		'in_product': 1,
		'unit_id': 1,
		'status': 1,
		'quantity': 1,
		'write_off_type': 1,
		'bool_devisible': true,
		'cost_price': 0,
		'description': '',
		'image': '',
		'cooking_time': '',
		'showSmiles': false,
		'sizes': [],
		'ingredients': [],
	})
	const [calculateDirection, setCalculateDirection] = useState('right')
	const [categories, setCategories] = useState([])
	const [categoriesInitial, setCategoriesInitial] = useState([])
	const [productTypes, setProductTypes] = useState([])
	const [productSystemTypes, setProductSystemTypes] = useState([])
	const [wms, setWms] = useState([])
	const [menu, setMenu] = useState([])
	const [units, setUnits] = useState([])
	const [elements, setElements] = useState([])
	const [taxCategories, setTaxCategories] = useState([])
	const [fiscalCodes, setFiscalCodes] = useState([])
	const [fiscalPackageCodes, setFiscalPackageCodes] = useState([])
	const [elementsDuplicate, setElementsDuplicate] = useState([])
	const [ingredientsHistory, setIngredientsHistory] = useState([])
	const [preparationPlaces, setPreparationPlaces] = useState([])
	const [activeTab, setActiveTab] = useState(1)
	const [mainActiveTab, setMainActiveTab] = useState(1)
	const [isOpen, setIsOpen] = useState(false)
	const [modalFiscal, setModalFiscal] = useState({
		'bool': false,
		'search': '',
		'fiscalCodes': [],
		'fiscalPackageCodes': [],
	})
	const [modalIngredientsHistory, setModalIngredientsHistory] = useState(false)
	const [showModifierModal, setShowModifierModal] = useState(false)
	const [showAddModifierModal, setShowAddModifierModal] = useState(false)
	const [showIngredientParamsModal, setShowIngredientParamsModal] = useState({ 'bool': false, 'index': null, 'params': null })
	const [modalDeleteIngredient, setModalDeleteIngredient] = useState(false)
	const [deleteModalIngredientParams, setDeleteModalIngredientParams] = useState({ 'id': 0, 'index': 0 })
	const [fiscalCode, setFiscalCode] = useState('')

	async function createUpdate(e, saveContinue = false) {
		e.preventDefault()

		var sendData = { ...data }
		sendData.ingredients = data.ingredients
		sendData.prices = data.prices
		sendData.error = false
		sendData.cooking_time = inputRef?.current?.inputElement?.value
		sendData.pos_id = posId

		if (sendData?.sizes?.length > 0) { // Если есть размеры цены обязательные
			for (let i = 0; i < sendData?.sizes.length; i++) {
				if (sendData?.sizes[i]['price'] === '' || sendData?.sizes[i]['sale_price'] === '') {
					sendData.error = true
				}
			}
		}

		if (sendData?.modifiers?.length > 0) { // Если есть модификаторы
			sendData.bool_modifiers = 1
		}

		var response;
		if (sendData.id) {
			response = await PUT('/products', sendData, { loader: true })
		} else {
			response = await POST('/products', sendData, { loader: true })
		}

		if (httpOk(response)) {
			if (!saveContinue) {
				navigate('/products')
			} else {
				setData({
					...data,
					'name': '',
					'sale_price': '',
					'in_product': 1,
					'unit_id': 1,
					'status': 1,
					'write_off_type': 1,
					'description': '',
					'image': '',
					'cooking_time': '',
					'showSmiles': false,
					'sizes': [],
					'ingredients': [],
				})
			}
		}
	}

	async function createFiscalCode() {
		const response = await POST('/products-fiscalization', {
			'fiscal_code': fiscalCode
		}, { loader: true })

		if (httpOk(response)) {
			setFiscalCode('')
			var response2 = await GET(`/helper/fiscal-codes`, {}, { loader: true })
			if (httpOk(response2)) setFiscalCodes(response2.data)
			toast.success(t('success'))
		}
	}

	function addSizes() {
		var dataCopy = { ...data }

		var size = {
			'name': '',
			'price': '',
			'sale_price': '',
			'bool_size_default': '',
		}

		if (!dataCopy.sizes) {
			dataCopy.sizes = []
		}

		dataCopy.sizes.push(size)
		setData(dataCopy)
	}

	function addIngredients() {
		var dataCopy = { ...data }
		var ingredient = {
			'element_id': null,
			'name': '',
			'unit_id': '',
			'unit_name': '',
			'second_unit_id': '',
			'price': '',
			'quantity': '',
			'loss': '',
			'in_product': '',
			'units': [],
			'changeable': true,
			'params': {
				"hall": true,
				"takeaway": true,
				"delivery": true,
			},
		}

		if (dataCopy.ingredients) {
			dataCopy.ingredients.push(ingredient)
			setData(dataCopy)
		}
	}

	async function addModifierToProduct(productModifiers) {
		var sendData = []
		for (let i = 0; i < productModifiers.modifiers.length; i++) {
			sendData.push({
				'product_id': data.id,
				'product_modifier_id': productModifiers.modifiers[i]['id']
			})
		}

		await POST('/products-modifier', sendData, { loader: true })
		setShowAddModifierModal(false)
		getData()
	}

	async function toggleModalIngredientsHistory(bool = false) {
		if (bool) {
			var response = await GET(`/products-ingredients-history/${id}`, {}, { loader: true })
			if (httpOk(response)) {
				setIngredientsHistory(response.data)
			}
		}

		setModalIngredientsHistory(bool)
	}

	function handleSelectInProduct(option) {
		var sale_price = ''
		if (option.id === 2 || option.id === 5) sale_price = 0

		setData({
			...data,
			'in_product': option.id,
			'product_system_type_id': null,
			'price': sale_price,
			'sale_price': sale_price,
			'menu_id': '',
		})
	}

	function handleIngridientChange(e, index) {
		var dataCopy = { ...data }

		if (e.target.type === 'number' || e.target.type === 'text') {
			dataCopy.ingredients[index][e.target.name] = e.target.value
		}

		if (e.target.type === 'checkbox') {
			dataCopy.ingredients[index][e.target.name] = e.target.checked
		}

		if (e.target.name === 'quantity') {
			calculateCostPrice(dataCopy)
		} else {
			setData(dataCopy)
		}
	}

	function toggleModalDeleteIngredient(item, index) {
		if (item.id) {
			setDeleteModalIngredientParams({ 'id': item.id, 'index': index })
			setModalDeleteIngredient(true)
		} else {
			var dataCopy = { ...data }
			dataCopy.ingredients.splice(index, 1)

			calculateCostPrice(dataCopy)
		}
	}

	async function deleteIngredient() {
		await DELETE(`/products-ingredient/${deleteModalIngredientParams.id}`, {}, { loader: true })
		var dataCopy = { ...data }
		dataCopy.ingredients.splice(deleteModalIngredientParams.index, 1)
		calculateCostPrice(dataCopy)
		setModalDeleteIngredient(false)
	}

	async function deleteModifier(item) {
		var response = await DELETE('/modifiers-product', { 'id': item.id }, { loader: true })

		if (httpOk(response)) {
			var dataCopy = { ...data }
			dataCopy.modifiers = dataCopy.modifiers.filter(element => element.id !== item.id);
			setData(dataCopy)
		}
	}

	function handleChange(e) {
		var dataCopy = { ...data }
		dataCopy[e.target.name] = e.target.value

		calculateCostPrice(dataCopy)
	}

	async function fileUpload(e) {
		const file = e.target.files[0];

		if (file) {
			const imgSize = file.size / (1024 * 1024);

			if (imgSize > 25) { // Проверка, если размер больше 25 МБ
				toast.error("Размер файла не должен превышать 25 МБ.");
				return;
			}

			// Используем промис для обработки загрузки изображения
			const validateImage = () => {
				return new Promise((resolve, reject) => {
					const reader = new FileReader();
					reader.onload = (event) => {
						const img = new Image();
						img.onload = () => {
							const imgWidth = img.width;
							const imgHeight = img.height;

							if (imgWidth < 800 || imgHeight < 600) {
								reject(new Error("Минимальный размер 800x600 px"));
							} else {
								resolve();
							}
						};
						img.onerror = () => reject(new Error("Failed to load image"));
						img.src = event.target.result;
					};
					reader.onerror = () => reject(new Error("Failed to read file"));
					reader.readAsDataURL(file);
				});
			};

			try {
				// Ждем завершения валидации изображения
				await validateImage();

				// Если прошла валидация, формируем данные и отправляем запрос
				let formData = new FormData();
				if (data.id) formData.append("id", data.id);
				formData.append("image", file);
				formData.append("db_name", 'products');
				formData.append("column_name", 'image');
				formData.append("path", 'products');

				let response;
				if (!data.id) {
					response = await FILE('/upload-image', formData, {}, { loader: true });
				} else {
					response = await FILE(`/update-image`, formData, {}, { loader: true });
				}

				if (httpOk(response)) {
					setData({ ...data, image: response.data.url });
				}
			} catch (error) {
				toast.error(error.message);
			}
		}
	}

	function calculateCostPrice(dataCopyFromDelete) {
		//debugger
		var dataCopy = { ...data }

		if (dataCopyFromDelete) {
			dataCopy = dataCopyFromDelete
		} else {
			dataCopy = { ...data }
		}

		if (dataCopy.ingredients.length) dataCopy['cost_price'] = 0;
		dataCopy['overall_weight_gross'] = 0
		dataCopy['overall_weight_net'] = 0
		dataCopy['overall_weight_finished'] = 0
		for (let i = 0; i < dataCopy.ingredients.length; i++) {
			if (!dataCopy.ingredients[i]['quantity']) {
				dataCopy.ingredients[i]['quantity'] = ''
			}

			if (dataCopy.ingredients[i]['weight_gross']) {
				dataCopy['overall_weight_gross'] += Number(dataCopy.ingredients[i]['weight_gross'])
			}

			if (dataCopy.ingredients[i]['weight_net']) {
				dataCopy['overall_weight_net'] += Number(dataCopy.ingredients[i]['weight_net'])
			}

			if (dataCopy.ingredients[i]['weight_finished']) {
				dataCopy['overall_weight_finished'] += Number(dataCopy.ingredients[i]['weight_finished'])
			}

			dataCopy['cost_price'] =
				dataCopy['cost_price'] +
				Number(dataCopy.ingredients[i]['average_price']) /
				Number(dataCopy.ingredients[i]['final_quantity'] ?? 1) *
				Number(dataCopy.ingredients[i]['quantity'])

			dataCopy.ingredients[i]['cost_price'] =
				Number(dataCopy.ingredients[i]['average_price']) /
				Number(dataCopy.ingredients[i]['final_quantity'] ?? 1) *
				Number(dataCopy.ingredients[i]['quantity'])
		}

		setData(dataCopy)
	}

	function toggleIngredientParamsModal(bool, index, item = {}) {
		if (bool) {
			setShowIngredientParamsModal({
				...showIngredientParamsModal,
				'bool': bool,
				'index': index,
				'params': item.params,
				'note': item.note,
				'changeable': item.changeable,
			})
		}
		if (!bool) {
			setShowIngredientParamsModal({ ...showIngredientParamsModal, 'bool': bool, 'index': null, 'params': null })
		}
	}

	function handleIngredientParamsChange(e, type) {
		var showIngredientParamsModalCopy = { ...showIngredientParamsModal }
		if (type === 'checkbox' && (
			e.target.name === "hall" ||
			e.target.name === "takeaway" ||
			e.target.name === "delivery"
		)) {
			showIngredientParamsModalCopy.params[e.target.name] = e.target.checked
		}

		if (type === 'checkbox' && e.target.name === "changeable") {
			showIngredientParamsModalCopy.changeable = e.target.checked
		}

		if (type === 'text') {
			showIngredientParamsModalCopy.note = e.target.value
		}

		setShowIngredientParamsModal(showIngredientParamsModalCopy)
	}

	function saveIngredientParams() {
		var dataCopy = { ...data }
		dataCopy.ingredients[showIngredientParamsModal.index]['params'] = showIngredientParamsModal.params
		dataCopy.ingredients[showIngredientParamsModal.index]['note'] = showIngredientParamsModal.note
		dataCopy.ingredients[showIngredientParamsModal.index]['changeable'] = showIngredientParamsModal.changeable

		setData(dataCopy)
		toggleIngredientParamsModal(false)
	}

	function handleParamsChange(key, value) {
		var dataCopy = { ...data }
		dataCopy.params[key] = value
		setData(dataCopy)
	}

	function handleChangeModifier(e, index) {
		var dataCopy = { ...data }
		if (e.target.type === 'number') {
			dataCopy.modifiers[index][e.target.name] = e.target.value

			if (e.target.name === 'min' && Number(dataCopy.modifiers[index]['min']) > 0) {
				dataCopy.modifiers[index]['required'] = true
			}
			if (
				e.target.name === 'min' &&
				(
					!dataCopy.modifiers[index]['min'] ||
					Number(dataCopy.modifiers[index]['min']) === 0
				)
			) {
				dataCopy.modifiers[index]['required'] = false
			}
		}

		if (e.target.type === 'checkbox') {
			dataCopy.modifiers[index][e.target.name] = !dataCopy.modifiers[index][e.target.name]
		}
		console.log(dataCopy)
		setData(dataCopy)
	}

	function handleChangeModifierProduct(e, parentIndex, index) {
		var dataCopy = { ...data }
		dataCopy.modifiers[parentIndex]['products'][index][e.target.name] = e.target.value

		dataCopy.modifiers[parentIndex][e.target.name] = 0
		for (let i = 0; i < dataCopy.modifiers[parentIndex]['products'].length; i++) {
			if (dataCopy.modifiers[parentIndex]['products'][i]['default_value']) {
				dataCopy.modifiers[parentIndex][e.target.name] +=
					Number(dataCopy.modifiers[parentIndex]['products'][i]['default_value'])
			}
		}

		setData(dataCopy)
	}

	function handleActiveTab(value) {
		setActiveTab(value)
	}

	function toggleModalFiscalization(bool = false) {
		setModalFiscal({
			'bool': bool,
			'search': '',
			'fiscalCodes': [],
			'fiscalPackageCodes': [],
		})
	}

	async function selectCategory(option) {
		setIsOpen(!isOpen)
		setData({ ...data, 'category_id': option?.id, 'category_name': option?.name, })
	}

	// REACTSELECT LOGIC
	function handleSelectSearch(value) {
		if (!value) {
			setElements([...elementsDuplicate])
			return
		}
		var elementsDuplicateCopy = [...elementsDuplicate]

		var filteredItems = elementsDuplicateCopy.filter(item => item.name.toLowerCase().includes(value.toLowerCase()))
		if (filteredItems[0]) {
			filteredItems[0]['selected'] = true
		}
		setElements(filteredItems)
	}

	function handleSelectElement(option, index) {
		console.log(option)
		var dataCopy = { ...data }
		var found = !!dataCopy.ingredients.find(item => item.element_id === option.id)
		if (found) {
			dataCopy.ingredients[index]['element_id'] = ''
			toast.error(`Ингридиент уже добавлен`)
			return
		}
		dataCopy.ingredients[index] = {
			'changeable': true,
			'params': {
				"hall": true,
				"takeaway": true,
				"delivery": true,
			},
		}

		dataCopy.ingredients[index]['quantity'] = ""
		dataCopy.ingredients[index]['loss_cold'] = ""
		dataCopy.ingredients[index]['loss_hot'] = ""
		dataCopy.ingredients[index]['weight_net'] = ""
		dataCopy.ingredients[index]['weight_finished'] = ""
		dataCopy.ingredients[index]['weight_gross'] = ""

		dataCopy.ingredients[index]['units'] = []
		dataCopy.ingredients[index]['element_id'] = option.id
		dataCopy.ingredients[index]['name'] = option.name
		dataCopy.ingredients[index]['average_price'] = option.average_price
		dataCopy.ingredients[index]['pos_id'] = option.pos_id
		dataCopy.ingredients[index]['loss'] = option.loss
		dataCopy.ingredients[index]['in_product'] = option.in_product
		dataCopy.ingredients[index]['product_type_name'] = option.product_type_name
		dataCopy.ingredients[index]['final_quantity'] = option.final_quantity
		if (option.second_unit_id) {
			dataCopy.ingredients[index]['second_unit_id'] = option.second_unit_id
			dataCopy.ingredients[index]['second_unit_quantity'] = option.final_quantity
			dataCopy.ingredients[index]['second_unit_name'] = option.second_unit_name

			// auto select unit
			dataCopy.ingredients[index]['exist_second_unit_id'] = true
			dataCopy.ingredients[index]['unit_id'] = option.unit_id
			dataCopy.ingredients[index]['unit_name'] = option.unit_name
			// auto select unit
			dataCopy.ingredients[index]['units'].push({
				'id': option.second_unit_id,
				'name': option.second_unit_name
			})
		} else {
			// auto select unit
			dataCopy.ingredients[index]['unit_id'] = option.unit_id
			dataCopy.ingredients[index]['exist_second_unit_id'] = false
			dataCopy.ingredients[index]['unit_name'] = option.unit_name
			// auto select unit

			dataCopy.ingredients[index]['units'].push({
				'id': option.unit_id,
				'name': option.unit_name
			})
		}

		setData(dataCopy)
	}

	function closeReactSelect() {
		setTimeout(() => {
			var elementsCopy = [...elements]
			for (let i = 0; i < elementsCopy.length; i++) {
				elementsCopy[i]['selected'] = false
			}
			if (elementsCopy[0] && elementsCopy[0]['selected'])
				elementsCopy[0]['selected'] = true
			setElements(elementsCopy)
		}, 100);
	}

	function handleTableKeyDown(event) {
		event.stopPropagation();
		var currentIndex = elements.findIndex(el => el.selected);
		if (currentIndex >= 0) {
			var elementsCopy = [...elements]
			elementsCopy[currentIndex].selected = false
			switch (event.key) {
				case "ArrowUp":
					if (currentIndex === 0) {
						elementsCopy[elements.length - 1].selected = true
						currentIndex = elements.length - 1
					} else {
						elementsCopy[currentIndex - 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6) - 59.2
					break;
				case "ArrowDown":
					if (currentIndex === elements.length - 1) {
						elementsCopy[0].selected = true
						currentIndex = 0
					} else {
						elementsCopy[currentIndex + 1].selected = true
					}
					scrollRef.current.scrollTop = (currentIndex * 29.6)
					break;
				default: break;
			}

			setElements(elementsCopy)
		}
	}
	// REACTSELECT LOGIC

	async function handleSelectTab() {
		setMainActiveTab(3)

		if (!fiscalCodes.length) {
			var response = await GET(`/helper/fiscal-codes`, {}, { loader: true })
			if (httpOk(response)) setFiscalCodes(response.data)
		}
	}

	function handleSelectFiscalCode(option, changePackage = true) {
		if (changePackage) {
			if (!option) {
				setData({ ...data, 'fiscal_code': null, 'fiscal_package_code': null })
				return
			}

			setData({ ...data, 'fiscal_code': option.id, 'fiscal_package_code': null })
			setFiscalPackageCodes(option.units)
		}

		setFiscalPackageCodes(option.units)
	}

	function handleSelectFiscalPackageCode(option) {
		if (!option) {
			setData({ ...data, 'fiscal_package_code': null })
			return
		}

		setData({ ...data, 'fiscal_package_code': option.id })
	}

	async function getData() {
		var response = await GET(`/products/${posId}/${id}`, {}, { loader: true })
		if (httpOk(response)) {
			response = response.data
			var responseUnits = await GET('/products-units')
			if (httpOk(responseUnits)) {
				setUnits(responseUnits.data)
			}

			for (let i = 0; i < response?.ingredients?.length; i++) {
				if (response.ingredients[i]['second_unit_quantity']) {
					if (response.ingredients[i]['loss'] && !response.ingredients[i]['id']) {
						response.ingredients[i]['quantity'] =
							response.ingredients[i]['second_unit_quantity'] -
							response.ingredients[i]['loss']
					}
				}
			}

			if (response) calculateCostPrice(response)

			var responseFiscalPackages = await GET('/helper/fiscal-codes')
			if (httpOk(responseFiscalPackages)) {
				setFiscalCodes(responseFiscalPackages.data)
				if (response.fiscal_code) {
					var option = responseFiscalPackages.data.find(item => item.id === response.fiscal_code)
					if (option?.id) setFiscalPackageCodes(option.units)
				}
			}
		}
	}

	async function getMenu() {
		var response = await GET('/helper/menu')
		if (httpOk(response)) setMenu(response.data)
	}

	async function getElements() {
		const response = await GET(`/products-elements/${posId}`)
		if (httpOk(response)) {
			setElements(response.data)
			setElementsDuplicate(response.data)
		}
	}

	async function getUnits() {
		const response = await GET('/products-units')
		if (httpOk(response)) setUnits(response.data)
	}

	async function getPreparationPlaces() {
		const response = await GET(`/helper/preparation-places?pos_id=${posId}`)
		if (httpOk(response)) setPreparationPlaces(response.data)
	}

	async function getPoses() {
		var responsePrices = await GET('/helper/poses')
		if (httpOk(responsePrices)) {
			responsePrices = responsePrices.data
			for (let i = 0; i < responsePrices.length; i++) {
				responsePrices[i]['pos_id'] = responsePrices[i]['id']
				responsePrices[i]['cost_price'] = 0
				responsePrices[i]['price'] = ''
				responsePrices[i]['sale_price'] = ''
			}
		}
	}

	async function getWms() {
		const response = await GET(`/helper/wms?pos_id=${posId}`)
		if (httpOk(response)) {
			setWms(response.data)
			const result = response.data.find(item => item.parent_id === null);
			if (result?.id) setData({ ...data, 'wms_id': result.id })
		}
	}

	async function getCategories() {
		var response = await GET('/helper/categories')
		response = response.data

		var arr = []
		for (let i = 0; i < response.length; i++) {
			response[i]['label'] = ` ${response[i]['name']}`
			response[i].child = false;
			if (response[i].parent_id) {
				const index = response.findIndex(x => x.id === response[i].parent_id)
				response[i].child = true;
				if (response[index]?.options && response[index]?.options?.length > 0) {
					response[index].options.push(response[i])
				} else {
					response[index].options = [response[i]]
				}
			} else {
				arr.push(response[i])
			}
		}

		setCategories(arr)
		setCategoriesInitial(response)
	}

	async function getTaxCategories() {
		const response = await GET(`/helper/tax-categories`)
		if (httpOk(response)) setTaxCategories(response.data)
	}

	async function getProductTypes() {
		const response = await GET(`/helper/product-types`)
		if (httpOk(response)) setProductTypes(response.data)
	}

	async function getProductSystemTypes() {
		const response = await GET(`/helper/product-system-types`)
		if (httpOk(response)) setProductSystemTypes(response.data)
	}

	const GroupHead = props => {
		return (
			<div style={{
				padding: '0',
				color: data.category_id === props.data.id ? '#fff' : '#535277',
				fontWeight: 'bold',
				backgroundColor: data.category_id === props.data.id ? '#2684FF' : 'transparent',
				fontSize: '1rem'
			}}
				onClick={() => selectCategory(props.data)}>
				<components.Option {...props} />
			</div>
		);
	};

	const Option = props => {
		return (
			<div style={{
				padding: props.data.child ? '0 0 0 20px' : '0',
				color: '#535277',
				fontWeight: props.data.parent_id === 0 ? 'bold' : 'normal',
				fontSize: '.9rem'
			}}>
				<components.Option {...props} />
			</div>
		);
	};

	function calculateWeight(index) {
		var dataCopy = { ...data }

		if (dataCopy.ingredients[index]['second_unit_quantity']) {
			if (calculateDirection === 'right') {
				if (dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['weight_net'] =
						(
							dataCopy.ingredients[index]['quantity'] -
							Number(dataCopy.ingredients[index]['quantity'] / 100 * dataCopy.ingredients[index]['loss_cold'])
						).toFixed(3)
				}

				if (!dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['weight_net'] = dataCopy.ingredients[index]['quantity']
				}

				if (dataCopy.ingredients[index]['loss_hot']) {
					dataCopy.ingredients[index]['weight_finished'] =
						(
							dataCopy.ingredients[index]['weight_net'] -
							Number(dataCopy.ingredients[index]['weight_net'] * dataCopy.ingredients[index]['loss_hot'] / 100)
						).toFixed(3)
				}

				if (!dataCopy.ingredients[index]['loss_hot']) {
					dataCopy.ingredients[index]['weight_finished'] = dataCopy.ingredients[index]['weight_net']
				}
			}

			if (calculateDirection === 'left') {
				if (dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['quantity'] =
						(
							Number(dataCopy.ingredients[index]['weight_net']) / Number(dataCopy.ingredients[index]['final_quantity']) +
							Number(dataCopy.ingredients[index]['weight_net'] / dataCopy.ingredients[index]['final_quantity'] * dataCopy.ingredients[index]['loss_cold'] / 100)
						).toFixed(3)
				}

				if (!dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['quantity'] =
						Number(dataCopy.ingredients[index]['weight_net'] / dataCopy.ingredients[index]['final_quantity'])
				}
			}

			dataCopy.ingredients[index]['weight_gross'] = dataCopy.ingredients[index]['quantity']
		}

		if (!dataCopy.ingredients[index]['second_unit_quantity']) {
			if (calculateDirection === 'right') {
				if (dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['weight_net'] =
						dataCopy.ingredients[index]['quantity'] -
						Number(dataCopy.ingredients[index]['quantity'] * dataCopy.ingredients[index]['loss_cold'] / 100)
				}

				if (!dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['weight_net'] = dataCopy.ingredients[index]['quantity']
				}

				if (dataCopy.ingredients[index]['loss_hot']) {
					dataCopy.ingredients[index]['weight_finished'] =
						dataCopy.ingredients[index]['weight_net'] -
						Number(dataCopy.ingredients[index]['weight_net'] * dataCopy.ingredients[index]['loss_hot'] / 100)
				}

				if (!dataCopy.ingredients[index]['loss_hot']) {
					dataCopy.ingredients[index]['weight_finished'] = dataCopy.ingredients[index]['weight_net']
				}
			}

			if (calculateDirection === 'left') {
				if (dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['quantity'] =
						(
							Number(dataCopy.ingredients[index]['weight_net']) +
							Number(dataCopy.ingredients[index]['weight_net'] * dataCopy.ingredients[index]['loss_cold'] / 100)
						).toFixed(3)
				}

				if (!dataCopy.ingredients[index]['loss_cold']) {
					dataCopy.ingredients[index]['quantity'] = dataCopy.ingredients[index]['weight_net']
				}
			}

			dataCopy.ingredients[index]['weight_gross'] = dataCopy.ingredients[index]['quantity']
		}

		calculateCostPrice(dataCopy)
	}

	useEffect(() => {
		if (id) {
			getData()
		} else {
			getUnits()
		}
		getWms()
		getMenu()
		getPoses()
		getElements()
		getCategories()
		getProductTypes()
		getProductSystemTypes()
		getTaxCategories()
		getPreparationPlaces()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex mb-2">
				<div className="d-flex">
					<h4 className="vertical-center">
						{t('product')}
					</h4>
					<div className="vertical-center mt-1">
						<i className="uil uil-angle-double-right fz-20"></i>
					</div>
					<div className="vertical-center mt-1">
						{!id ?
							<h6>{t('create')}</h6>
							:
							<h6>{t('edit')}</h6>
						}
					</div>
					{id &&
						<Fragment>
							<div className="vertical-center mt-1">
								<i className="uil uil-angle-double-right fz-20"></i>
							</div>
							<div className="vertical-center mt-1">
								{data.pos_name}
							</div>
						</Fragment>
					}
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<form autoComplete="off">
						<div className="tabs tabs-sm mb-2">
							<ul>
								<li className={mainActiveTab === 1 ? 'active' : ''}
									onClick={() => setMainActiveTab(1)}>
									<span className="link">{t('main')}</span>
								</li>
								<li className={mainActiveTab === 2 ? 'active ' : ''}
									onClick={() => setMainActiveTab(2)}>
									<span className="link">{t('ingredients')}</span>
								</li>
								<li className={mainActiveTab === 3 ? 'active ' : ''}
									onClick={() => handleSelectTab(3)}>
									<span className="link">{t('fiscalization')}</span>
								</li>
							</ul>
						</div>
						<div className={`row mb-5 ${mainActiveTab === 1 ? '' : 'd-none'}`}>
							<div className="col-md-5">
								<div className="flex-gap10">
									<div className="w-50">
										<div className="con-upload">
											<div className="con-img-upload">
												{data.image &&
													<div className="img-upload">
														<button type="button" className="btn-x-file" onClick={() => setData({ ...data, 'image': '' })}>
															<i className="uil-times"></i>
														</button>
														<img src={`https://backend.kingplovv.uz/uploads/products/${data.image}`}
															style={{ maxWidth: 'none', maxHeight: '100%' }} alt={data.image} />
													</div>
												}
												{!data.image &&
													<div className="con-input-upload">
														<input type="file" onChange={(e) => fileUpload(e)} />
														<span className="text-input fz14">
															{t('image2')}
														</span>
													</div>
												}
											</div>
										</div>
									</div>
									<div className="w-50">
										<div className="form-group">
											<label>{t("name2")}<span className="required-mark">*</span></label>
											<div className="position-relative">
												<input type="text" className="form-control" name="name" autoFocus
													value={data.name ?? ''}
													onChange={(e) => setData({ ...data, 'name': e.target.value })} />
												<div className="input-smile-icon"
													onClick={() => setData({ ...data, 'showSmiles': !data.showSmiles })}>🙂</div>
												{data.showSmiles &&
													<div className="input-smile-wrapper">
														{smiles.map((item, index) => (
															<div key={index} onClick={() => setData({ ...data, 'name': data.name + smiles[index] })}>
																{smiles[index]}
															</div>
														))}
													</div>
												}
											</div>
										</div>
										<div className="form-group">
											<label>{t("menu")}</label>
											<Select
												options={menu}
												value={menu.find(option => option.id === data.menu_id)}
												onChange={(option) => setData({ ...data, 'menu_id': option.id })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
										<div className="form-group w-100">
											<label>{t("preparation_places")}</label>
											<Select
												isClearable
												options={preparationPlaces}
												value={preparationPlaces.find(option => option.id === data.preparation_place_id)}
												onChange={(option) => setData({ ...data, 'preparation_place_id': option ? option.id : null })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
								</div>
								<div className="flex-gap10">
									<div className="form-group w-100">
										<label>{t('type')}<span className="required-mark">*</span></label>
										<Select
											isDisabled={data.id}
											options={productTypes}
											value={productTypes.find(option => option.id === data.in_product)}
											onChange={(option) => handleSelectInProduct(option)}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
									<div className="form-group w-100">
										<label>{t('system_types')}</label>
										<Select
											isDisabled={!(data.in_product === 5 && !data.id)}
											options={productSystemTypes}
											value={productSystemTypes.find(option => option.id === data.product_system_type_id) || null}
											onChange={(option) => setData({ ...data, 'product_system_type_id': option.id })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
								</div>
								{data.in_product === 3 &&
									<div className="form-check">
										<input id="print_with_main" className="form-check-input" type="checkbox"
											checked={data?.print_with_main}
											onChange={(e) => setData({ ...data, 'print_with_main': e.target.checked })}
										/>
										<label className="form-check-label" htmlFor="print_with_main">
											{t('print_with_main_product')}
										</label>
									</div>
								}
								<div className="flex-gap10">
									<div className="form-group w-100">
										<label>{t("cost_price")}</label>
										<input type="text" className="form-control" name="cost_price"
											disabled
											value={formatMoney(data.cost_price) ?? ''}
											onChange={() => { }} />
									</div>
									<div className="form-group w-100">
										<label>{t('sale_price')}<span className="required-mark">*</span></label>
										<input
											disabled={data.in_product === 5}
											type="number"
											className="form-control"
											name="sale_price"
											value={data.sale_price ?? ''}
											onChange={(e) => handleChange(e)} />
									</div>
									<div className="form-group w-100">
										<label>{t('income')}<span className="required-mark">*</span></label>
										<input type="text"
											disabled
											className="form-control"
											value={formatMoney(data.sale_price - data.cost_price) ?? ''} />
									</div>
								</div>
								<div className="flex-gap10">
									<div className="form-group w-100">
										<label>{t('wms')}<span className="required-mark">*</span></label>
										<Select
											options={wms}
											value={wms.find(option => option.id === data.wms_id)}
											onChange={(option) => setData({ ...data, 'wms_id': option.id })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
									<div className="form-group w-100">
										<label>{t('unit')}<span className="required-mark">*</span></label>
										<Select
											options={units}
											value={units.find(option => option.id === data.unit_id)}
											onChange={(option) => setData({ ...data, 'unit_id': option.id })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
									<div className="form-group w-100">
										<label>{t('weight')}</label>
										<input type="number" className="form-control"
											name="weight"
											value={data.weight ?? ''}
											onChange={(e) => setData({ ...data, 'weight': e.target.value })} />
									</div>
								</div>
								<div className="flex-gap10">
									<div className="form-group w-100">
										<label>{t("write_off_type")}<span className="required-mark">*</span></label>
										<Select
											options={writeOffTypes}
											value={writeOffTypes.find(option => option.id === data.write_off_type)}
											onChange={(option) => setData({ ...data, 'write_off_type': option.id })}
											placeholder=""
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
									<div className="form-group w-100">
										<label>{t("time")}</label>
										<MaskedInput
											mask={[/[0-9]/, /\d/, ':', /\d/, /\d/, ':', /\d/, /\d/,]}
											className="form-control"
											placeholder="00:00:00"
											guide={true}
											ref={inputRef}
											value={data.cooking_time ?? ''}
										/>
									</div>
								</div>
								<div className="flex-gap10">
									<div className="form-group w-100">
										<label>{t('category')}</label>
										<Select
											components={{ GroupHeading: GroupHead, Option }}
											isClearable
											isSearchable={false}
											onMenuOpen={() => setIsOpen(true)}
											onMenuClose={() => setIsOpen(false)}
											onBlur={() => setIsOpen(false)}
											menuIsOpen={isOpen}
											classNamePrefix='react-select'
											options={categories}
											value={categoriesInitial.find(option => option.id === data.category_id)}
											onChange={(option) => selectCategory(option)}
											placeholder={t('categories')}
											noOptionsMessage={() => t('list_empty')}
											getOptionLabel={(option) => option.name}
											getOptionValue={(option) => option.id}
										/>
									</div>
								</div>

								<div className="form-group w-100">
									<label>{t("description")}</label>
									<textarea className="form-control" name="description"
										value={data.description ?? ''}
										onChange={(e) => setData({ ...data, 'description': e.target.value })} />
								</div>
								<hr />
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('on_sale')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="status"
											checked={data?.status}
											onChange={(e) => setData({ ...data, 'status': e.target.checked })}
										/>
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('devisible_product')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="bool_devisible"
											checked={data?.bool_devisible}
											onChange={(e) => setData({ ...data, 'bool_devisible': e.target.checked })}
										/>
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('custom_price')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="is_custom_price"
											checked={data?.is_custom_price}
											onChange={(e) => setData({ ...data, 'is_custom_price': e.target.checked })}
										/>
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('external_service')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="bool_telegram_bot"
											checked={data?.bool_telegram_bot}
											onChange={(e) => setData({ ...data, 'bool_telegram_bot': e.target.checked })}
										/>
									</div>
								</div>
								<div className="d-flex justify-content-between">
									<p className="fw-600 vertical-center">{t('print_ingredients_kitchen')}</p>
									<div className="form-check form-switch form-switch-lg">
										<input type="checkbox" className="form-check-input" name="is_print_ingredients"
											checked={data?.is_print_ingredients}
											onChange={(e) => setData({ ...data, 'is_print_ingredients': e.target.checked })}
										/>
									</div>
								</div>
							</div>
							<div className="col-md-7">
								<div className="tabs tabs-sm">
									<ul>
										<li className={activeTab === 1 ? 'active ' : ''}
											onClick={() => handleActiveTab(1)}>
											<span className={`link ${(data.in_product === 2 || data.in_product === 3) && 'disabled'}`}>
												{t('sizes')}
											</span>
										</li>
										{id &&
											<li className={activeTab === 2 ? 'active' : ''}
												onClick={() => handleActiveTab(2)}>
												<span className={'link ' + (data.in_product === 3 ? 'disabled ' : '')}>
													{t('modifiers')}
												</span>
											</li>
										}
										{(data.id) &&
											<li className={activeTab === 3 ? 'active' : ''}
												onClick={() => handleActiveTab(3)}>
												<span className="link">{t('in_products')}</span>
											</li>
										}
										<li className={activeTab === 4 ? 'active ' : ''}
											onClick={() => handleActiveTab(4)}>
											<span className="link">
												{t('params')}
											</span>
										</li>
									</ul>
								</div>
								<div className={activeTab !== 1 ? 'd-none' : ''}>
									<div className="input-borer-only p-3 my-3">
										<div className="d-flex justify-content-between mb-2">
											<h4 className="me-2">{t('sizes')}</h4>
											<div className="table-action-button table-action-success-button"
												onClick={() => addSizes()}>
												<i className="uil-plus"></i>
											</div>
										</div>
										<Size
											posId={posId}
											data={data}
											setData={setData}
											activeTab={activeTab}>
										</Size>
									</div>
								</div>
								<div className={activeTab !== 2 ? 'd-none' : ''}>
									<div className="input-borer-only p-3 my-3" style={{ 'minHeight': '240px' }}>
										<div className="d-flex justify-content-between mb-2">
											<div className="vertical-center">
												<h4>{t("modifiers")}</h4>
											</div>
											<div className="d-flex gap-2">
												<button type="button" className="btn btn-primary btn-rounded btn-wide"
													onClick={() => setShowAddModifierModal(true)}>
													{t('add')}
												</button>
												<button type="button" className="btn btn-primary btn-rounded btn-wide"
													onClick={() => setShowModifierModal(true)}>
													{t('create')}
												</button>
											</div>
										</div>

										<div className="table-responsive">
											<table className="table table-bordered">
												<thead>
													<tr>
														<th style={{ 'width': '30%' }}>{t('name2')}</th>
														<th style={{ 'width': '5%' }} className="text-end">Мин</th>
														<th style={{ 'width': '5%' }} className="text-end">Макс</th>
														<th style={{ 'width': '30%' }} className="text-end">По умолчанию</th>
														<th style={{ 'width': '30%' }} className="text-center">Обязательный</th>
														<th style={{ 'minWidth': '33px' }}></th>
													</tr>
												</thead>
												<tbody>
													{data?.modifiers?.map((modifier, index) => (
														<Fragment key={index}>
															<tr>
																<td><b>{modifier.name}</b></td>
																<td className="td-input">
																	<input
																		type="number"
																		name="min"
																		className="form-control text-end"
																		placeholder="0"
																		value={modifier.min ?? ''}
																		onChange={(e) => handleChangeModifier(e, index)}
																	/>
																</td>
																<td className="td-input">
																	<input
																		disabled
																		type="number"
																		name="max"
																		className="form-control text-end"
																		placeholder="0"
																		value={modifier.max ?? ''}
																		onChange={(e) => handleChangeModifier(e, index)}
																	/>
																</td>
																<td className="td-input">
																	<input
																		disabled
																		type="number"
																		name="default_value"
																		className="form-control text-end"
																		placeholder="0"
																		value={modifier.default_value ?? ''}
																	/>
																</td>
																<td className="text-center">
																	<input
																		type="checkbox"
																		name="required"
																		className="form-check-input"
																		checked={modifier.required}
																		onChange={(e) => handleChangeModifier(e, index)}
																	/>
																</td>
																<td className="text-end">
																	<button type="button" className="table-action-button table-action-danger-button"
																		onClick={() => deleteModifier(modifier)}>
																		<i className="uil uil-times"></i>
																	</button>
																</td>
															</tr>
															{modifier?.products?.map((product, productIndex) => (
																<tr key={productIndex}>
																	<td className="td-ellipsis">
																		<div className="ms-2">- {product.name}</div>
																	</td>
																	<td></td>
																	<td></td>
																	<td className="td-input">
																		<input
																			type="number"
																			name="default_value"
																			className="form-control text-end"
																			placeholder="0"
																			value={product.default_value ?? ''}
																			onChange={(e) => handleChangeModifierProduct(e, index, productIndex)}
																		/>
																	</td>
																	<td></td>
																	<td></td>
																</tr>
															))}
														</Fragment>
													))}
												</tbody>
											</table>
										</div>
									</div>

									<Modifiers
										showModifierModal={showModifierModal}
										setShowModifierModal={setShowModifierModal}
										showAddModifierModal={showAddModifierModal}
										setShowAddModifierModal={setShowAddModifierModal}
										addModifierToProduct={addModifierToProduct}
										activeTab={activeTab}>
									</Modifiers>
								</div>
								<div className={activeTab !== 3 ? 'd-none' : ''}>
									<div className="input-borer-only p-3 my-3">
										<div className="d-flex justify-content-between mb-2">
											<h4>{t('used_in_products')}</h4>
										</div>
										<div className="table-responsive">
											<table className="table table-bordered">
												<thead>
													<tr>
														<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
														<th style={{ 'width': '30%' }}>{t("product")}</th>
														<th style={{ 'width': '60%' }}></th>
														<th style={{ 'width': '10%' }} className="text-end">{t("quantity")}</th>
													</tr>
												</thead>
												<tbody>
													{data?.productInProducts?.length > 0 &&
														<>
															{data?.productInProducts?.map((item, index) => (
																<tr key={index}>
																	<td className="text-center">{index + 1}</td>
																	<Link to={`/products/update/${posId}/${item.product_id}`} target="_blank" rel="noopener noreferrer">
																		{item.product_name}
																	</Link>
																	<td></td>
																	<td className="text-end">{item.quantity}</td>
																</tr>
															))}
														</>
													}
												</tbody>
											</table>
										</div>
									</div>
								</div>
								<div className={activeTab !== 4 ? 'd-none' : ''}>
									<div className="input-borer-only p-3 my-3 d-none">
										<h4 className="fw-600">{t('tg_bot')}</h4>
										<div className="d-flex justify-content-between">
											<p className="fw-600 vertical-center">{t('text')}</p>
											<div className="form-group">
												<input type="text" className="form-control"
													name="tg_text"
													maxLength={4}
													placeholder={t('text')}
													value={data?.params?.tg_text ?? ''}
													onChange={(e) => handleParamsChange('tg_text', e.target.value)} />
											</div>
										</div>
										<div className="d-flex justify-content-between">
											<p className="fw-600 vertical-center">{t('color')}</p>
											<div className="form-group">
												<div className="position-relative">
													<input type="text" className="form-control"
														placeholder={t('color')}
														value={data?.params?.tg_color ?? ''}
														onChange={(e) => handleParamsChange('tg_color', e.target.value)} />
													<i className="color-picker-icon uil-angle-down"
														onClick={() => setData({ ...data, 'bool_color_picker': !data.bool_color_picker })}>
													</i>
												</div>
												{data.bool_color_picker &&
													<SketchPicker
														style={{ 'zIndex': 1 }}
														className="position-absolute"
														onChangeComplete={(option) => handleParamsChange('tg_color', option.hex)}
													/>
												}
											</div>
										</div>
										<div className="d-flex justify-content-between">
											<p className="fw-600 vertical-center">{t('bg_color')}</p>
											<div className="form-group">
												<div className="position-relative">
													<input type="text" className="form-control"
														placeholder={t('bg_color')}
														value={data?.params?.tg_bg_color ?? ''}
														onChange={(e) => handleParamsChange('tg_bg_color', e.target.value)} />
													<i className="color-picker-icon uil-angle-down"
														onClick={() => setData({ ...data, 'bool_color_picker2': !data.bool_color_picker2 })}>
													</i>
												</div>
												{data.bool_color_picker2 &&
													<SketchPicker
														style={{ 'zIndex': 1 }}
														className="position-absolute"
														onChangeComplete={(option) => handleParamsChange('tg_bg_color', option.hex)}
													/>
												}
											</div>
										</div>
									</div>
								</div>

								<h6>{t('energy_value_per')}</h6>
								<div className="d-flex gap-2">
									<div className="form-group w-100">
										<label>{t('proteins')}</label>
										<input type="number" className="form-control" name="proteins"
											value={data.proteins ?? ''}
											onChange={(e) => setData({ ...data, 'proteins': e.target.value })} />
									</div>
									<div className="form-group w-100">
										<label>{t('fat')}</label>
										<input type="number" className="form-control" name="fat"
											value={data.fat ?? ''}
											onChange={(e) => setData({ ...data, 'fat': e.target.value })} />
									</div>
									<div className="form-group w-100">
										<label>{t('carbohydrates')}</label>
										<input type="number" className="form-control" name="carbohydrates"
											value={data.carbohydrates ?? ''}
											onChange={(e) => setData({ ...data, 'carbohydrates': e.target.value })} />
									</div>
									<div className="form-group w-100">
										<label>{t('calories')}</label>
										<input type="number" className="form-control" name="calories"
											value={data.calories ?? ''}
											onChange={(e) => setData({ ...data, 'calories': e.target.value })} />
									</div>
								</div>
							</div>
						</div>

						<div className={mainActiveTab === 2 ? '' : 'd-none'}>
							<div className="table-responsive">
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '30%' }}>{t("name2")}</th>
											<th style={{ 'width': '10%' }}>{t("type")}</th>
											<th style={{ 'width': '5%' }} className="text-nowrap">{t("unit")}</th>
											<th style={{ 'width': '10%' }} className="text-end">{t("quantity")}</th>
											<th style={{ 'width': '10%' }}>Брутто, {t('kg')}</th>
											<th style={{ 'width': '10%' }}>{t('cold_processing_loss')} %</th>
											<th style={{ 'width': '10%' }}>Нетто, {t('kg')}</th>
											<th style={{ 'width': '10%' }}>{t('hot_processing_loss')} %</th>
											<th style={{ 'width': '10%' }}>{t('finished_product')} {t('kg')}</th>
											<th style={{ 'width': '10%' }} className="text-nowrap text-end">{t("cost_price")}</th>
											<th style={{ 'width': '10%' }} className="text-nowrap text-end">1-{t("cost_price")}</th>
											<th style={{ 'minWidth': '64px' }} className="text-center"></th>
										</tr>
									</thead>
									<tbody>
										{data?.ingredients?.map((item, index) => (
											<tr key={index}>
												<td className="text-center" title={item?.id ?? null}>
													{item.id &&
														<Link to={`/products/update/${posId}/${item.element_id}`} target="_blank" rel="noopener noreferrer">
															{index + 1}
														</Link>
													}
													{!item.id &&
														<span>{index + 1}</span>
													}
												</td>
												<td className="td-ellipsis">
													{(id && item.id) ?
														<div title={formatDate(item.created_at, 'dd.MM.yy HH:mm')}>{item.name}</div>
														:
														<div>
															<ReactSelect
																search={handleSelectSearch}
																value={item.name}
																index={index}
																scrollRef={scrollRef}
																options={elements}
																onClose={() => closeReactSelect()}
																selectItem={(option) => handleSelectElement(option, index)}
																onKeyUp={(e) => {
																	if (e.keyCode === 40 || e.keyCode === 38) {
																		handleTableKeyDown(e)
																	}
																}}
																table={
																	<table className="table mb-0">
																		<tbody ref={tbodyRef}>
																			{elements.map((selectItem, selectIndex) => (
																				<tr
																					id={selectItem.id}
																					className={`cursor ${((selectItem.selected || selectItem.id === item.element_id) && 'selected')}`}
																					tabIndex={-1}
																					key={selectIndex}
																					onClick={() => handleSelectElement(selectItem, index)}
																					onKeyDown={(e) => handleTableKeyDown(e, selectItem, index)}>
																					<td>{selectItem.name}</td>
																					<td>{selectItem.product_type_name}</td>
																					<td className="text-end text-nowrap">{formatMoney(selectItem.average_price)}</td>
																				</tr>
																			))}
																		</tbody>
																	</table>
																}
															/>
														</div>
													}
												</td>
												<td>{item.product_type_name}</td>
												<td>{item.second_unit_id ? item.second_unit_name : item.unit_name}</td>
												<td className="td-input" style={!item.quantity ? { 'borderBottom': '2px solid red' } : {}}>
													<input type="number" className="form-control text-end" name="quantity"
														disabled={item.id}
														placeholder="0"
														value={item.quantity ?? ''}
														onChange={(e) => handleIngridientChange(e, index)}
														onKeyUp={(e) => {
															if (e.keyCode === 13) {
																calculateWeight(index)
															}
														}} />
												</td>
												<td className="text-end">{formatMoney(item.weight_gross, 3)}</td>
												<td className="td-input">
													<input type="number" className="form-control text-end" name="loss_cold"
														disabled={item.id}
														placeholder="0"
														value={item.loss_cold ?? ''}
														onChange={(e) => handleIngridientChange(e, index)}
														onKeyUp={(e) => {
															if (e.keyCode === 13) {
																calculateWeight(index)
															}
														}} />
												</td>
												<td className="td-input">
													<input type="number" className="form-control text-end" name="weight_net"
														disabled={item.id}
														placeholder="0"
														value={item.weight_net ?? ''}
														onChange={(e) => handleIngridientChange(e, index)}
														onKeyUp={(e) => {
															if (e.keyCode === 13) {
																calculateWeight(index)
															}
														}} />
												</td>
												<td className="td-input">
													<input type="number" className="form-control text-end" name="loss_hot"
														placeholder="0"
														value={item.loss_hot ?? ''}
														onChange={(e) => handleIngridientChange(e, index)}
														onKeyUp={(e) => {
															if (e.keyCode === 13) {
																calculateWeight(index)
															}
														}} />
												</td>
												<td className="td-input">
													<input type="number" className="form-control text-end" name="weight_finished"
														placeholder="0"
														value={item.weight_finished ?? ''}
														onChange={(e) => handleIngridientChange(e, index)}
														onKeyUp={(e) => {
															if (e.keyCode === 13) {
																calculateWeight(index)
															}
														}} />
												</td>
												<td className="text-end">
													{item.cost_price ? formatMoney(item.cost_price) : 0}
												</td>
												<td className="text-nowrap text-end" >
													{item.average_price ? formatMoney(item.average_price) : 0}
												</td>
												<td className="vertical-middle">
													<div className="d-flex justify-content-center gap-1">
														{data.in_product !== 2 &&
															<div className="table-action-button table-action-primary-button"
																onClick={() => toggleIngredientParamsModal(true, index, item)}>
																<i className="uil-setting"></i>
															</div>
														}
														<div className="table-action-button table-action-danger-button"
															onClick={() => toggleModalDeleteIngredient(item, index)}>
															<i className="uil-times"></i>
														</div>
													</div>
												</td>
											</tr>
										))}
									</tbody>
									<tfoot>
										<tr>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												<div className="d-flex w-100">
													<button type="button" className="btn-sm btn-primary w-100"
														onClick={() => addIngredients()}>
														{t('add')}
													</button>
												</div>
											</td>
											<td style={{ 'padding': 0 }}>
												<div className="d-flex w-100">
													<button type="button" className="btn-sm btn-primary w-100"
														onClick={() => {
															if (calculateDirection === 'right') {
																setCalculateDirection('left')
															} else {
																setCalculateDirection('right')
															}
														}}>
														{calculateDirection === 'right' &&
															<i className="uil-arrow-right"></i>
														}
														{calculateDirection === 'left' &&
															<i className="uil-arrow-left"></i>
														}
													</button>
												</div>
											</td>
											<td></td>
											<td></td>
											<td className="text-nowrap text-end"><b>{formatMoney(data.overall_weight_gross, 2)}</b></td>
											<td></td>
											<td className="text-nowrap text-end"><b>{formatMoney(data.overall_weight_net, 2)}</b></td>
											<td></td>
											<td className="text-nowrap text-end"><b>{formatMoney(data.overall_weight_finished, 2)}</b></td>
											<td className="text-nowrap text-end"><b>{formatMoney(data.cost_price, 2)}</b></td>
											<td></td>
											<td colSpan={1} style={{ 'padding': 0 }}>
												{id &&
													<div className="d-flex w-100">
														<button type="button" className="btn-sm btn-primary w-100"
															onClick={() => toggleModalIngredientsHistory(true)}>
															<i className="uil-list-ui-alt"></i>
														</button>
													</div>
												}
											</td>
										</tr>
									</tfoot>
								</table>
								<div className="col-md-2">
									<div className="form-group w-100">
										<label>{t('quantity')} ({findKeyFromArrayByValue(units, 'id', data.unit_id, 'name')})</label>
										<input type="number" className="form-control"
											disabled={data.in_product === 1}
											name="quantity"
											value={data.quantity ?? ''}
											onChange={(e) => setData({ ...data, 'quantity': e.target.value })} />
									</div>
									<div className="form-group w-100">
										<label>{t('weight')}</label>
										<input type="number" className="form-control"
											name="weight"
											value={data.weight ?? ''}
											onChange={(e) => setData({ ...data, 'weight': e.target.value })} />
									</div>
								</div>
							</div>
						</div>

						<div className={mainActiveTab === 3 ? '' : 'd-none'}>
							<div className="row">
								<div className="col-md-6">
									<div className="form-group w-100">
										<div className="form-group">
											<div className="d-flex justify-content-between">
												<label>ИКПУ</label>
												<div className="table-action-button table-action-success-button"
													onClick={() => toggleModalFiscalization(true)}>
													<i className="uil-plus"></i>
												</div>
											</div>
											<Select
												isClearable
												options={fiscalCodes}
												value={fiscalCodes.find(option => option.id === data.fiscal_code)}
												onChange={(option) => handleSelectFiscalCode(option)}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>

									<div className="form-group w-100">
										<div className="form-group">
											<label>{t("unit")}</label>
											<Select
												isClearable
												options={fiscalPackageCodes}
												value={fiscalPackageCodes.find(option => option.id === data.fiscal_package_code)}
												onChange={(option) => handleSelectFiscalPackageCode(option)}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="d-flex justify-content-between">
										<p className="fw-600 vertical-center">{t('marking')}</p>
										<div className="form-check form-switch form-switch-lg">
											<input type="checkbox" className="form-check-input" name="is_marking"
												checked={data?.is_marking}
												onChange={(e) => setData({ ...data, 'is_marking': e.target.checked })}
											/>
										</div>
									</div>
								</div>
								<div className="col-md-6">
									<div className="d-flex gap-2">
										<div className="form-group w-100">
											<label>{t('barcode')}</label>
											<input type="number" className="form-control" name="barcode"
												value={data.barcode ?? ''}
												onChange={(e) => handleChange(e)} />
										</div>
										<div className="form-group w-100">
											<label>{t('code')}(PLU)</label>
											<input type="number" className="form-control" name="code"
												value={data.code ?? ''}
												onChange={(e) => handleChange(e)} />
										</div>
									</div>
									<div className="form-group w-100">
										<div className="form-group">
											<div className="d-flex justify-content-between">
												<label>{t('tax_categories')}</label>
											</div>
											<Select
												isClearable
												options={taxCategories}
												value={taxCategories.find(option => option.id === data.tax_category_id)}
												onChange={(option) => setData({ ...data, 'tax_category_id': option ? option.id : null })}
												placeholder=""
												noOptionsMessage={() => t('list_empty')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div className="btn-wrapper gap-2">
							<Link className="btn btn-warning btn-rounded btn-wide" to="/products">
								{t('cancel')}
							</Link>
							{!data.id &&
								<button type="button" className="btn btn-secondary btn-rounded btn-wide"
									onClick={(e) => createUpdate(e, true)}>
									{t('save')}
									<i className="uil uil-arrow-right"></i>
								</button>
							}
							<button type="button" className="btn btn-primary btn-rounded btn-wide"
								onClick={(e) => createUpdate(e)}>
								{t('save')}
							</button>
						</div>
					</form>
				</div>
			</div>

			{/* MODAL INGREDIENT PARAMS */}
			<Modal show={showIngredientParamsModal.bool} animation={false} centered
				dialogClassName="update-modal-width" backdrop="static" onHide={() => {
					toggleIngredientParamsModal(false)
				}}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('settings')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<span className="text-danger">{t('write_off_ingredient_only')}</span>
					<div className="d-flex justify-content-between mb-2">
						<p className="fw-600 vertical-center">{t('hall')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" name="hall"
								checked={showIngredientParamsModal?.params?.hall}
								onChange={(e) => handleIngredientParamsChange(e, 'checkbox')} />
						</div>
					</div>
					<div className="d-flex justify-content-between mb-2">
						<p className="fw-600 vertical-center">{t('takeaway')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" name="takeaway"
								checked={showIngredientParamsModal?.params?.takeaway}
								onChange={(e) => handleIngredientParamsChange(e, 'checkbox')} />
						</div>
					</div>
					<div className="d-flex justify-content-between mb-2">
						<p className="fw-600 vertical-center">{t('delivery')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" name="delivery"
								checked={showIngredientParamsModal?.params?.delivery}
								onChange={(e) => handleIngredientParamsChange(e, 'checkbox')} />
						</div>
					</div>
					<hr />
					<div className="d-flex justify-content-between mb-2">
						<p className="fw-600 vertical-center">{t('changeable')}</p>
						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" name="changeable"
								checked={showIngredientParamsModal?.changeable}
								onChange={(e) => handleIngredientParamsChange(e, 'checkbox')} />
						</div>
					</div>
					<input type="text" className="form-control" name="note"
						autoComplete="off"
						placeholder={t('note')}
						value={showIngredientParamsModal?.note ?? ''}
						onChange={(e) => handleIngredientParamsChange(e, 'text')} />
					<div className="d-flex gap-2 w-100 mt-3">
						<button type="button" className="btn btn-outline-warning w-100"
							onClick={() => toggleIngredientParamsModal(false)}>
							{t('cancel')}
						</button>
						<button type="button" className="btn btn-primary w-100"
							onClick={saveIngredientParams}>
							{t('save')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL INGREDIENT PARAMS */}

			{/* MODAL INGREDIENT HISTORY */}
			<Modal show={modalIngredientsHistory} animation={false} centered size="lg"
				dialogClassName="update-modal-width" backdrop="static"
				onHide={() => toggleModalIngredientsHistory()}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('history')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="table-responsive">
						<table className="table table-bordered mb-0">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '80%' }}>{t('name2')}</th>
									<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('quantity')}</th>
									<th style={{ 'width': '10%' }} className="text-start text-nowrap">{t('unit')}</th>
									<th style={{ 'minWidth': '125px' }} className="text-center">{t('created')}</th>
									<th style={{ 'minWidth': '125px' }} className="text-center">{t('deleted')}</th>
									<th style={{ 'minWidth': '125px' }} className="text-center">{t('deleted_by')}</th>
								</tr>
							</thead>
							<tbody>
								{ingredientsHistory?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td className="td-ellipsis" title={item.name}>{item.name}</td>
										<td className="text-end">{item.quantity}</td>
										<td className="text-start">{item.unit_name}</td>
										<td className="text-center">{formatDate(item.created_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="text-center">{formatDate(item.deleted_at, 'dd.MM.yyyy HH:mm')}</td>
										<td className="text-center" title={item.deleted_by}>{item.deleted_by}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL INGREDIENT HISTORY */}

			{/* MODAL NEW FISCAL CODE */}
			<Modal Modal show={modalFiscal.bool} animation={false} centered
				backdrop="static" onHide={() => toggleModalFiscalization(false)}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('fiscalization')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="w-100">
						<div className="form-group">
							<label>ИКПУ [<a href="https://tasnif.soliq.uz/" target="_blank" rel="noreferrer">tasnif.soliq.uz</a>]</label>
							<input type="number" className="form-control"
								autoComplete="off"
								value={fiscalCode}
								onChange={(e) => setFiscalCode(e.target.value)} />
						</div>

						<button type="submit" className="btn btn-primary w-100 mt-2"
							onClick={() => createFiscalCode()}>
							{t('add')}
						</button>
					</div>
				</Modal.Body>
			</Modal >
			{/* MODAL NEW FISCAL CODE */}

			<DeleteModal
				modalDelete={modalDeleteIngredient}
				setModalDelete={setModalDeleteIngredient}
				deleteItem={deleteIngredient}>
			</DeleteModal>
		</>
	)
}

export default CreateUpdate